/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Редактировать стандартный объект меню для ассоциации.
 */
export interface ObjectMenuDefaultView { 
    /**
     * тип сущности из таблицы EntityTypes
     */
    entityType?: number;
    /**
     * 
     */
    codeName: string;
    /**
     * 
     */
    languageCode: string;
    /**
     * 
     */
    title: string;
    /**
     * 
     * @deprecated
     */
    isVisible?: boolean;
    visibilityOption?: string;
    /**
     * 
     */
    id?: string;
}

